import { Component } from 'react'
import { connect } from 'react-redux'
import smartlookClient from 'smartlook-client'

class SmartLookClient extends Component {

  componentWillMount() {
    smartlookClient.init('54c45920c788d87025e6ee80a1e6dda67b738478')
  }

  componentDidUpdate (prevProps) {
    if (this.props.userData !== prevProps.userData) {
      if (!this.props.userData.id) {
        return smartlookClient.anonymize();
      }
      smartlookClient.identify(this.props.userData.id, {
        name: this.props.userData.name,
        email: this.props.userData.email
     })
    }
  }

  render () {
    return null
  }
}

const mapDispatchToProps = (dispatch) => ({
})

const mapStateToProps = (state) => ({
  userData: state.auth.userData
})

export default connect(mapStateToProps, mapDispatchToProps)(SmartLookClient)



// WEBPACK FOOTER //
// ./src/Components/SmartLookClient.js